import { useContext, useCallback } from "react"
import { UIContext } from "../layout"
import useSiteMetadata from "../hooks/useSiteMetadata"

export default function useHubspotFormSubmission(endpoint) {
  const {
    state: { location },
  } = useContext(UIContext)

  const metadata = useSiteMetadata()

  const pageUri = metadata.siteURL + location.pathname

  return useCallback(
    async data => {
      const submissionData = Object.keys(data).map(key => ({
        name: key,
        value: data[key],
      }))

      const submission = {
        fields: [...submissionData],
        context: {
          pageUri,
          pageName: document.title,
        },
      }

      try {
        let hutk = document.cookie
          .split("; ")
          .find(row => row.startsWith("hubspotutk"))
          .split("=")[1]

        submission.context = {
          ...submission.context,
          hutk,
        }

        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(submission),
        })

        return await response.json()
      } catch (e) {
        throw e
      }
    },
    [endpoint, pageUri]
  )
}
